const NAME = "COURSES_MASTER";

export default NAME;
